
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {
  },
})
export default class extends Vue {
  @Prop({ required: true }) private roomPrice!: any;

  private apiUrl = process.env.VUE_APP_BASE_API;

  private alldayPrice = {
    quantity: 0,
    price: 0,
    usable: true,
  }

  private handleClickAllday() {
    this.$confirm('정말 모든 일자에 일괄 적용하시겠습니까?', '요금/일정 일괄적용', {
      confirmButtonText: '적용',
      cancelButtonText: '취소',
      type: 'info',
    }).then(() => {
      this.roomPrice.mondayUsable = this.alldayPrice.usable;
      this.roomPrice.tuesdayUsable = this.alldayPrice.usable;
      this.roomPrice.wednesdayUsable = this.alldayPrice.usable;
      this.roomPrice.thursdayUsable = this.alldayPrice.usable;
      this.roomPrice.fridayUsable = this.alldayPrice.usable;
      this.roomPrice.saturdayUsable = this.alldayPrice.usable;
      this.roomPrice.sundayUsable = this.alldayPrice.usable;
      this.roomPrice.holidayUsable = this.alldayPrice.usable;
      this.roomPrice.holidayBeforeUsable = this.alldayPrice.usable;

      this.roomPrice.mondayQuantity = this.alldayPrice.quantity;
      this.roomPrice.tuesdayQuantity = this.alldayPrice.quantity;
      this.roomPrice.wednesdayQuantity = this.alldayPrice.quantity;
      this.roomPrice.thursdayQuantity = this.alldayPrice.quantity;
      this.roomPrice.fridayQuantity = this.alldayPrice.quantity;
      this.roomPrice.saturdayQuantity = this.alldayPrice.quantity;
      this.roomPrice.sundayQuantity = this.alldayPrice.quantity;
      this.roomPrice.holidayQuantity = this.alldayPrice.quantity;
      this.roomPrice.holidayBeforeQuantity = this.alldayPrice.quantity;

      this.roomPrice.mondayPrice = this.alldayPrice.price;
      this.roomPrice.tuesdayPrice = this.alldayPrice.price;
      this.roomPrice.wednesdayPrice = this.alldayPrice.price;
      this.roomPrice.thursdayPrice = this.alldayPrice.price;
      this.roomPrice.fridayPrice = this.alldayPrice.price;
      this.roomPrice.saturdayPrice = this.alldayPrice.price;
      this.roomPrice.sundayPrice = this.alldayPrice.price;
      this.roomPrice.holidayPrice = this.alldayPrice.price;
      this.roomPrice.holidayBeforePrice = this.alldayPrice.price;
    });
  }
}
